module.exports = __webpack_public_path__ + "static/media/PFCLS.068c1f0d.jpg";